<template>
  <div class="global-navi-side-menu-footer-block">
    <div class="global-navi-declaration">
      <a :href="declarationLink">
        <div class="global-navi-declaration-img-icon"></div>
        <div class="global-navi-declaration-target">
          <p class="global-navi-at-cosme">@cosme宣言</p>
          <p class="global-navi-safety">安心してご利用いただけるサイト運営を目指して</p>
        </div>
      </a>
    </div>
    <div class="global-navi-micael">
      <a :href="micaelLink">
        <div class="global-navi-micael-img-icon"></div>
        <div class="global-navi-micael-target">
          <p class="global-navi-micael-title">@cosmeのミカエルって？</p>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import Config from '../../../libs/config';

export default {
  name: 'side-menu-footer',
  data() {
    const declarationLink = new URL('/static/sng/', Config.SERVICE_LINK.ATCOSME.SP.URL).href;
    const micaelLink = new URL('/static/spc/about-micael/', Config.SERVICE_LINK.ATCOSME.SP.URL).href;
    return {
      declarationLink: declarationLink,
      micaelLink     : micaelLink,
    };
  },
};
</script>
